export default __webpack_public_path__ + "static/media/user.ddb86e62.svg";